import React, { Component } from 'react';
import Time from 'material-ui/svg-icons/device/access-time';
import moment from 'moment';
import { isFVlite, checkMobile, isSentryBreadcrumbs } from '../lib/lib';

const formattedSeconds = (sec) =>
  Math.floor(sec / 60) +
    ':' +
  ('0' + sec % 60).slice(-2);

export default class Timer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      secondsElapsed: 0,
      timerFontColor: "#8996A9",
      lastClearedIncrementer: null
    };
   
    if(!props.sessionsPremiumRoom && !this.props.isWebinar && !this.props.isBreakout && !isFVlite()){

      localStorage.setItem('pastLimitTime', moment().unix())
      let endtime = localStorage.getItem('endTime');
      let now = moment()
      if( endtime && moment(moment(endtime, 'X').add(1, 'minutes')).isAfter(now)){
        alert("無料プランでは40分しか連続して使用できません。有料プランへアップグレードしてください。");
        window.location.href = "https://admin.dd-talk.net/admin/settings/manage-plans";
      }

      this.state.secondsElapsed = 2400
    }
    this.incrementer = null;
  }

  componentDidMount () {
    this.handleStartTimer();
  }

  componentWillUnmount () {
    this.incrementer && clearInterval(this.incrementer);
    this.incrementer = false;
  }

  handleStartTimer () {
    try{
    this.incrementer = setInterval(() =>{
      if(!this.props.sessionsPremiumRoom && !this.props.isWebinar && !this.props.isBreakout && !isFVlite() ){
        if(this.props.isCountStart){
          if(this.state.secondsElapsed == 300){
            this.setState({
              timerFontColor: "red"
            })
          }
          if(this.state.secondsElapsed == 0){
            localStorage.setItem('endTime', moment().unix())
            alert("無料プランでは40分しか連続して使用できません。有料プランへアップグレードしてください。");
            window.location.href = "https://admin.dd-talk.net/admin/settings/manage-plans";
          }
          this.setState({
            secondsElapsed: this.state.secondsElapsed - 1
          })
        }
      }else{
        this.setState({
          secondsElapsed: this.state.secondsElapsed + 1
        })
      }
    }, 1000);
  }
  catch(error){
   const message = "Timer handleStartTimer() failed"
   isSentryBreadcrumbs(error,message)
  } 
  }

  render () {
    return (
      <div>  
      { !isFVlite() &&       
      <div className='flex items-center ml1' style={checkMobile() ? {} : {position: "absolute",height: '8vh',bottom: "5vh",zIndex: 150}}>
        <Time className='mr3' style={{ fill: this.state.timerFontColor }} />
        { !this.props.isWebinar && !this.props.sessionsPremiumRoom &&  <div style={{ fontSize: 18, color: this.state.timerFontColor }}>
        残り
        </div> }
        <div style={{ fontSize: 20, color: this.state.timerFontColor }}>
       {formattedSeconds(this.state.secondsElapsed)}s
        </div>
      </div>
      }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Timer.js